/**
 * @fileoverview PATCH handler for the "/:app_group_id/canvas/:workflow_id/steps/position" endpoint
 */
import { reactQueryMutationAdapter } from "@dashboardApi/apis/reactQueryFetcherAdapters";

import fetch from "@lib/fetch";

import { appGroupIdCanvasWorkflowIdStepsPositionCacheKeys } from "./constants";
import type { PatchAppGroupIdCanvasWorkflowIdStepsPositionProps, PatchCanvasStepsPositionResult } from "./types";

export const patchCanvasStepsPosition = reactQueryMutationAdapter(
  appGroupIdCanvasWorkflowIdStepsPositionCacheKeys,
  ({
    appGroupId,
    workflowId,
    steps,
    isPostLaunchDraft,
  }: PatchAppGroupIdCanvasWorkflowIdStepsPositionProps): Promise<PatchCanvasStepsPositionResult> => {
    return fetch(
      `/${appGroupId}/canvas/${workflowId}/steps/position`,
      "PATCH",
      { steps, is_post_launch_draft: isPostLaunchDraft },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
